<template>
  <section class="primary-classes" aria-labelledby="primary-classes-title">
    <div class="section-heading">
      <p>PRIMARY SCHOOL · CLASS SYSTEM</p>
      <h2 id="primary-classes-title">小学两大班型</h2>
      <span>与初中班型采用统一的课程介绍方式，清晰呈现课程定位与培养目标</span>
    </div>

    <article
      v-for="(item, index) in classes"
      :key="item.name"
      class="class-card"
      :class="{ reverse: index % 2 === 1 }"
    >
      <div class="card-copy">
        <div class="title-row">
          <div>
            <p class="english-title">{{ item.english }}</p>
            <h3>{{ item.name }}</h3>
          </div>
          <span class="former-name">原名：{{ item.former }}</span>
        </div>

        <div class="facts">
          <p><strong>课程定位</strong>{{ item.positioning }}</p>
          <p><strong>课程结构</strong>{{ item.structure }}</p>
          <p><strong>培养目标</strong>{{ item.goal }}</p>
          <p class="detail">{{ item.detail }}</p>
        </div>
      </div>

      <div class="card-visual">
        <img :src="item.image" :alt="item.name + '课程配图'" />
        <span class="class-index">0{{ index + 1 }}</span>
      </div>
    </article>
  </section>
</template>

<script>
export default {
  name: "CourseGroupSubsection",
  data() {
    return {
      classes: [
        {
          name: "小学创新班",
          english: "Primary School Innovation Class",
          former: "超常班",
          positioning: "面向小学数学竞赛，与初中国培班保持一贯制培养体系。",
          structure: "70% 纯奥数内容，30% 小学课内重难点；在原超常班体系上调整学习进度，难度与课容量保持一致。",
          goal: "帮助学生成为主城区每届约 30000 名学子中的 TOP200。",
          detail: "五年级完成小学创新班课程后，可衔接初中国培班，形成小学到初中的连续培养路径。",
          image: "/static/img/course-image-533.png",
        },
        {
          name: "小学勤思班",
          english: "Primary School Qinsi Class",
          former: "尖子班",
          positioning: "完整覆盖小学校内内容，在夯实课内基础的前提下进行深入拓展。",
          structure: "40% 奥数思维拓展，60% 课内知识，兼顾校内衔接、初高中数学思想与高阶解题方法。",
          goal: "让学生成为校内佼佼者，成长为主城区每届约 30000 名学子中的 TOP2000。",
          detail: "拓展内容包括鸡兔同笼、行程问题、方程与数列，以及分数裂项、分类讨论、枚举法等解题思想。",
          image: "/static/img/course-image.png",
        },
      ],
    };
  },
};
</script>

<style scoped>
.primary-classes {
  left: 172px;
  position: absolute;
  top: 898px;
  width: 1568px;
}

.section-heading {
  align-items: flex-end;
  display: flex;
  height: 104px;
  margin-bottom: 48px;
  position: relative;
}

.section-heading::before {
  background: linear-gradient(180deg, #069ee0 0%, #025dd4 100%);
  content: "";
  height: 72px;
  left: 0;
  position: absolute;
  top: 18px;
  width: 6px;
}

.section-heading p {
  color: #1674cc;
  font-family: "Poppins", Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 600;
  left: 30px;
  letter-spacing: 2.8px;
  margin: 0;
  position: absolute;
  top: 11px;
}

.section-heading h2 {
  color: #00183c;
  font-family: "PingFang SC-Semibold", "PingFang SC", Helvetica, sans-serif;
  font-size: 40px;
  font-weight: 600;
  line-height: 56px;
  margin: 0 0 0 30px;
}

.section-heading span {
  color: #6c7a90;
  font-family: "PingFang SC-Regular", "PingFang SC", Helvetica, sans-serif;
  font-size: 18px;
  margin: 0 0 10px 30px;
}

.class-card {
  background: #f9fafb;
  box-shadow: 0 18px 54px rgba(0, 24, 60, 0.08);
  display: flex;
  height: 450px;
  margin-bottom: 64px;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.class-card:last-child {
  margin-bottom: 0;
}

.class-card.reverse {
  flex-direction: row-reverse;
}

.card-copy {
  background: rgba(249, 250, 251, 0.97);
  flex: 1;
  min-width: 0;
  padding: 42px 58px 36px;
}

.title-row {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  min-height: 78px;
  position: relative;
}

.title-row h3 {
  color: #1c4b8a;
  font-family: "PingFang SC-Semibold", "PingFang SC", Helvetica, sans-serif;
  font-size: 36px;
  font-weight: 600;
  line-height: 44px;
  margin: 0;
  position: relative;
  z-index: 1;
}

.english-title {
  color: rgba(0, 0, 0, 0.06);
  font-family: "Poppins", Helvetica, sans-serif;
  font-size: 34px;
  font-weight: 600;
  left: 0;
  line-height: 42px;
  margin: 0;
  position: absolute;
  top: 28px;
  white-space: nowrap;
}

.former-name {
  background: #eaf3ff;
  border: 1px solid #d6e8ff;
  border-radius: 18px;
  color: #2c67a8;
  font-family: "PingFang SC-Medium", "PingFang SC", Helvetica, sans-serif;
  font-size: 15px;
  line-height: 28px;
  margin-left: 20px;
  padding: 0 16px;
  white-space: nowrap;
}

.facts {
  color: #00183c;
  font-family: "PingFang SC-Regular", "PingFang SC", Helvetica, sans-serif;
  margin-top: 14px;
}

.facts p {
  font-size: 17px;
  line-height: 30px;
  margin: 0 0 7px;
}

.facts strong {
  color: #1c4b8a;
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  margin-right: 16px;
  min-width: 72px;
}

.facts .detail {
  border-top: 1px solid #dfe7f1;
  color: #52627a;
  font-size: 15px;
  line-height: 25px;
  margin-top: 12px;
  padding-top: 10px;
}

.card-visual {
  background: #dcebf8;
  flex: 0 0 560px;
  height: 450px;
  overflow: hidden;
  position: relative;
}

.card-visual::after {
  background: linear-gradient(180deg, rgba(0, 24, 60, 0) 58%, rgba(0, 24, 60, 0.38) 100%);
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.card-visual > img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.class-index {
  bottom: 24px;
  color: rgba(255, 255, 255, 0.95);
  font-family: "Poppins", Helvetica, sans-serif;
  font-size: 58px;
  font-weight: 600;
  left: 28px;
  line-height: 1;
  position: absolute;
  z-index: 2;
}

.reverse .class-index {
  left: auto;
  right: 28px;
}
</style>
